import script from "./DocLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocLogin.vue?vue&type=script&setup=true&lang=ts"

import "./DocLogin.vue?vue&type=style&index=0&id=56879b10&lang=css"

const __exports__ = script;

export default __exports__